import commonAPI from 'apis/commonAPI';

export const loadSettings = () => async dispatch => {
    const result = await commonAPI.loadSettings();
    dispatch({
        type: 'LOAD_SETTINGS',
        payload: result.data
    });
};